module.exports = __webpack_public_path__ + "static/accountancy_software_logo-d9479725822aab93223186d4cd9cb31f.png";